import React, { Component } from 'react';
import { LoadWrapper, MapFilter, MapTitle, MapWrapper, OvalContainer, Text } from '../../../Download/Load/DownloadLoadElement';
import { fetchPredefMaps, getMapXML } from '../../../../../../Utils/VisorsUtils';
import { Oval } from 'react-loader-spinner';
import { getTranslatedKey } from '../../../../../../Utils/TranslateUtils';
import { DeleteSearchIcon, DeleteSearchIconButton, GraySearchButton } from '../../../../../../Catalog/CatalogElements';
import { FaSearch } from 'react-icons/fa';
import { TitleStyle } from '../LocalMaps/LocalMapsElement';

export default class DefaultMaps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      filterText: '',
      defaultMaps: [],
      filteredMaps: []
    };
  }

  componentDidMount = async () => {
    this.setState({ loading: true });
    let defaultMaps = await fetchPredefMaps();

    defaultMaps = defaultMaps.filter((map) => map.nom);
    defaultMaps.sort((a, b) => {
      return a.nom.toUpperCase() < b.nom.toUpperCase() ? -1 : 1;
    });

    this.setState({ defaultMaps: defaultMaps, loading: false });
  };

  componentWillUnmount = () => {
    this.setState({ defaultMaps: undefined });
  };

  loadMap = async (id) => {
    const xml = await getMapXML(id);
    await this.props.loadMap(xml);
  };

  filterResults = (text) => {
    const filteredResults = this.state.defaultMaps.filter((word) => word.nom.toUpperCase().includes(text.toUpperCase()));
    this.setState({ filteredMaps: filteredResults, filterText: text });
  };

  onDeleteSearchBtnClick = () => {
    this.setState({ filterText: '' });
    this.filterResults('');
  };

  render() {
    if (this.state.loading) {
      return (
        <OvalContainer>
          <Oval
            height={window.innerHeight > 400 ? 80 : 40}
            width={window.innerHeight > 400 ? 80 : 40}
            color="#febf00"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#ccc"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </OvalContainer>
      );
    } else {
      return (
        <LoadWrapper>
          {this.state.defaultMaps ? (
            <>
              <TitleStyle>{getTranslatedKey('defaultMapsTitle')}</TitleStyle>
              <div style={{ display: 'flex', height: '28px', marginTop: '15px' }}>
                <GraySearchButton title={getTranslatedKey('cerca')}>
                  <FaSearch
                    style={{
                      verticalAlign: 'middle',
                      transform: 'translate(0px, -2px)'
                    }}
                  />
                </GraySearchButton>
                <MapFilter
                  value={this.state.filterText}
                  placeholder={getTranslatedKey('filterMaps')}
                  onChange={(e) => this.filterResults(e.target.value)}
                />
                <DeleteSearchIconButton title={getTranslatedKey('esborra')} onClick={() => this.onDeleteSearchBtnClick()}>
                  <DeleteSearchIcon text={this.state.filterText} alt={getTranslatedKey('altDeleteIcon')} title={getTranslatedKey('esborrarCerca')}>
                    <path
                      xmlns="http://www.w3.org/2000/svg"
                      d="M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12L19,15.59M22,3A2,2 0 0,1 24,5V19A2,2 0 0,1 22,21H7C6.31,21 5.77,20.64 5.41,20.11L0,12L5.41,3.88C5.77,3.35 6.31,3 7,3H22M22,5H7L2.28,12L7,19H22V5Z"
                    />
                  </DeleteSearchIcon>
                </DeleteSearchIconButton>
              </div>
              <MapWrapper>
                {this.state.filteredMaps.length === 0 && this.state.filterText === '' ? (
                  this.state.defaultMaps.map((map) => (
                    <MapTitle
                      onMouseEnter={() => this.setState({ mapHovered: map.map_id })}
                      onMouseLeave={() => this.setState({ mapHovered: false })}
                      hovered={this.state.mapHovered === map.map_id}
                      title={map.nom}
                      onClick={() => this.loadMap(map.id)}>
                      {map.nom}
                    </MapTitle>
                  ))
                ) : this.state.filteredMaps.length > 0 ? (
                  this.state.filteredMaps.map((map) => (
                    <MapTitle
                      onMouseEnter={() => this.setState({ mapHovered: map.map_id })}
                      onMouseLeave={() => this.setState({ mapHovered: false })}
                      hovered={this.state.mapHovered === map.map_id}
                      title={map.nom}
                      onClick={() => this.loadMap(map.id)}>
                      {map.nom}
                    </MapTitle>
                  ))
                ) : (
                  <Text>{getTranslatedKey('noResultsMap')}</Text>
                )}
              </MapWrapper>
            </>
          ) : (
            <Text>{getTranslatedKey('noResultsMap')}</Text>
          )}
        </LoadWrapper>
      );
    }
  }
}
